import React from 'react';
import TitleText from '../../../../Components/TitleText/TitleText';
import studio from '../../../../Assets/Sister Concern/spacejam.jpg';
import udvash from '../../../../Assets/Sister Concern/udvash.png';

import './SisterConcern.css'
const SisterConcern = () => {
    return (
        <>
            <TitleText title1="Sister" title2="Concern" position="center" />
            <div className='container text-center logoContainer'>
                <div>
                    <a href="https://studiospacejam.com/" target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: "white" }}>
                        <img src={studio} alt="" height="150px" width="150px" className='' />
                        <h3>Studio SpaceJam</h3>
                    </a>

                </div>
                <div>
                    <a href="https://udvash.com/HomePage" target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: "white" }}>
                        <img src={udvash} alt="" height="150px" width="150px" />
                        <h3>Udvash</h3>
                    </a>
                </div>
            </div>
        </>
    );
};

export default SisterConcern;